<template>
  <div class="expert-search max-content">
    <van-sticky>
      <top :title="nav_title" :color="color"></top>

    </van-sticky>
    <img :src="img_src" v-if="img_src" />
    <div class="content" :style="!img_src ? 'top:68px' : ''">
      <div class="head">
        <van-search shape="round" v-model="name" placeholder="请输入专家姓名/医院名称" @input="searchExpert" />
      </div>
      <div class="names">
        <p class="whole">全部专家</p>
        <van-index-bar :index-list="indexList" ref="indexBars" :sticky="false">
          <div v-for="(item, index) in peopleList" :key="index">
            <van-index-anchor :index="index" />
            <div v-for="(row, index) in item" :key="index" class="item" @click="goDetail(row)">
              <div class="cell-avatar">
                <img :src="row.photo" alt="" v-if="row.photo" />
                <img src="../../../assets/images/System/people_default.png" alt="" v-else />
              </div>
              <div class="cell-name">
                <h4>{{ row.name }}</h4>
                <p v-if="meeting_id != 581">{{ row.company }}</p>
              </div>
            </div>
          </div>
        </van-index-bar>
      </div>
    </div>
  </div>
</template>
<script>
import { SearchWriters, MeetingsDetails, ButtonDetail } from '../../../config/interface.js'
import Top from '../components/Top'
import { Toast, Sticky } from 'vant';
export default {
  components: {
    Top, Sticky
  },
  data() {
    return {
      //peopleList:[],
      name: "",
      indexList: [],
      peopleList: [],
      img_src: '',
      color: "",
      nav_title: '讲者检索',
      button_id: this.$route.query.button_id ? this.$route.query.button_id : this.$route.query.b_id,
      scrollTop: 0,
      currentIndex: '',
      // indexBar2: ''

    }
  },

  computed: {
    meeting_id() {
      return this.$route.query.meeting_id ? this.$route.query.meeting_id : this.$route.query.MT_id
    },
    keywords() {
      return this.$route.query.keywords ? this.$route.query.keywords : null
    }
  },
  activated() {
    this.$nextTick(() => {
      console.log('activated', this.currentIndex)
      if (this.currentIndex) {
        this.scrollToIndex(this.currentIndex)
      }
    });
  },
  mounted() {
    this.getImg();
    this.searchExpert();
    this.getButtonData();
    if (this.keywords) {
      this.name = this.keywords
      console.log(this.name)
      this.searchExpert(this.$route.query.keywords);
    }
  },
  methods: {
    scrollToIndex(index) {
      const indexBar = this.$refs.indexBars.$el; // 获取 IndexBar 的 DOM 元素
      const anchors = indexBar.querySelectorAll('.van-index-anchor'); // 获取所有锚点
      let targetAnchor = null;
      anchors.forEach(anchor => {
        if (anchor.textContent === index) {
          targetAnchor = anchor;
        }
      });
      if (targetAnchor) {
        targetAnchor.scrollIntoView(); // 滚动到目标锚点
      } else {
        console.log('Index not found');
      }
    },

    goDetail(val) {
      if (val.first_ren_ping) {
        this.currentIndex = val.first_ren_ping
      } else {
        this.currentIndex = "#"
      }
      this.$router.push({
        path: "/vascularNews/expert/detail",
        query: {
          meeting_id: this.meeting_id,
          writer_id: val.id,
        },
      });
    },
    //获取按钮信息
    getButtonData() {
      if (this.button_id) {
        const url = ButtonDetail;
        let params = {
          button_id: this.button_id
        }
        const method = "POST";
        fetch(url, params, method)
          .then((res) => {
            if (res.code == 0) {
              let data = res.data;
              this.nav_title = data.name
              if (res.data.theme_color_hex) {
                this.color = res.data.theme_color_hex
              } else {
                this.color = '#901D22'
              }
              if (common.is_weixin()) {
                common.wxShare(data.share_title, data.share_sub_title, data.share_img);
              }
            }
          })

      }
    },
    getImg() {
      const url = MeetingsDetails;
      const method = 'POST';
      let params = {
        meeting_id: this.meeting_id
      };
      fetch(url, params, method)
        .then((res) => {
          if (res.code == 0) {
            this.img_src = res.data.writer_search_background
          }
        })
    },
    searchExpert(val) {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '',
      });
      const url = SearchWriters;
      const method = 'POST'
      let params = {
        meeting_id: this.meeting_id,
        keywords: val
      };
      fetch(url, params, method).then((res) => {
        Toast.clear();
        if (res.code == 0) {
          this.peopleList = res.data;
          this.indexList = Object.keys(res.data);
          // console.log(this.indexList);
        }
      })
    }
  },
};
</script>
<style lang="scss">
.expert-search {
  position: relative;
  z-index: 1;

  img {
    width: 100%;
    // height: 120px;
    // background: red;
  }

  .content {
    background: white;
    // position: absolute;
    // top: 170px;
    // z-index: 2;
    // width: 90%;
    // left: 5%;

    .head {
      border-radius: 1rem;
    }

    .whole {
      font-size: 16px;
      padding: 5px 10px 10px 15px;
      color: #535353;
    }

    .van-index-anchor {
      background: #f5f5f5;
    }

    .item {
      padding: 10px;
      // border-bottom:1px solid #F7F7F7 ;
      display: flex;

      div {
        display: inline;
        vertical-align: middle;

        img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }
      }

      .cell-name {
        padding: 0 10px;
        width: 90%;
        border-bottom: 1px solid #f7f7f7;
        display: flex;
        flex-direction: column;
        justify-content: center;

        p {
          padding: 0;
          margin: 0;
          color: #666;
        }

        h4 {
          font-size: 14px;
          color: #535353;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Expert/Search.vue